import { useEffect, useRef } from "react"

export type NativePlayerState =
  | "idle"
  | "loading"
  | "playing"
  | "paused"
  | "stopped"
  | "interrupted"

export type NativePlayerEvent =
  | {
      event: "state"
      state: NativePlayerState
    }
  | {
      event: "progress"
      current: number
      duration: number
    }
  | {
      event: "ended"
    }
  | {
      event: "error"
      message: string
    }
  | {
      event: "next"
    }
  | {
      event: "previous"
    }

type Listener = (event: NativePlayerEvent) => void

export function useNativePlayer(listener: Listener) {
  const listenerRef = useRef(listener)

  useEffect(() => {
    listenerRef.current = listener
  }, [listener])

  useEffect(() => {
    const handleNativeEvent = (event: Event) => {
      const customEvent =
        event as CustomEvent<NativePlayerEvent>

      if (!customEvent.detail) return

      listenerRef.current(customEvent.detail)
    }

    window.addEventListener(
      "mixtape:native-player",
      handleNativeEvent
    )

    return () => {
      window.removeEventListener(
        "mixtape:native-player",
        handleNativeEvent
      )
    }
  }, [])
}